export default "__VITE_ASSET__pfhdr7jS__"